// extracted by mini-css-extract-plugin
export default {"tabContent":"rI534","tabContentActive":"CvAHO"};